module.exports = __webpack_public_path__ + "static/media/4.40e734b6.jpg";